import { AxiosError } from 'axios';

import { ZEE_FINANCIAL_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

import { CreateZeeFinancialApiPayload } from './createZeeFinancial';
import { GetZeeFinancialApiResponse } from './getZeeFinancial';

export const updateZeeFinancial = async (
  payload: CreateZeeFinancialApiPayload
): Promise<ApiResponse<GetZeeFinancialApiResponse>> => {
  try {
    const response = await apiManager.put(ZEE_FINANCIAL_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
